import Vue from 'vue'
import moment from 'moment/moment'

Vue.filter('fromNow', function (value) {
  if (value) {
    return moment(String(value)).fromNow()
  }
})

// USAGE: <span>{{yourDateString | formatDate}}</span>
Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(value).format('MMM Do YYYY')
  }
})

// USAGE: <span>{{yourDateString | formatTime}}</span>
Vue.filter('formatTime', function (value) {
  if (value) {
    return moment(value).format('H:mm:ss')
  }
})

// USAGE: <span>{{yourDateString | formatTime}}</span>
Vue.filter('formatDateTime', function (value) {
  if (value) {
    return moment(value).format('MMM Do YYYY H:mm:ss')
  }
})

// USAGE: {{ file.size | prettyBytes }}
Vue.filter('prettyBytes', function (num) {
  // jacked from: https://github.com/sindresorhus/pretty-bytes
  if (typeof num !== 'number' || isNaN(num)) {
    throw new TypeError('Expected a number')
  }

  var exponent
  var unit
  var neg = num < 0
  var units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  if (neg) {
    num = -num
  }

  if (num < 1) {
    return (neg ? '-' : '') + num + ' B'
  }

  exponent = Math.min(Math.floor(Math.log(num) / Math.log(1000)), units.length - 1)
  num = (num / Math.pow(1000, exponent)).toFixed(2) * 1
  unit = units[exponent]

  return (neg ? '-' : '') + num + ' ' + unit
})



// WEBPACK FOOTER //
// ./src/filters/index.js